import { createApi } from '@core/fetch'

export default {
  eSchoolList: createApi(
    // '/p/wedding/index.php/Admin/APIBusinessCollege/web_index'
    '/p/wedding/index.php/admin/APIBusinessCollege/index_v2'
  ),
  getTypes: createApi(
    '/p/wedding/index.php/admin/APIBusinessCollege/index_category'
  )
}
